// extracted by mini-css-extract-plugin
module.exports = {"section":"page_section__89_Iq"};